module.exports = __webpack_public_path__ + "img/list.9658ce05.png";